import { __extends, __makeTemplateObject, __decorate, __assign as _assign, __metadata } from '../../node_modules/tslib/tslib.es6.js';
import '../../node_modules/lit/node_modules/@lit/reactive-element/reactive-element.js';
import { html as x } from '../../node_modules/lit-html/lit-html.js';
import '../../node_modules/lit-element/lit-element.js';
import { property as n } from '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/property.js';
import '../../node_modules/@babel/runtime/regenerator/index.js';
import '../../node_modules/lit/node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import getClassName from '../../node_modules/@fmr-ap142296/brick-helpers/dist/src/functions/get-class-name.js';
import { PvdSlotifyBaseComponent } from '../pvd-base-component/pvd-slotify-base-component.js';
import { Inline } from '../pvd-utils/enums/inline.js';
import { TextAlign } from '../pvd-utils/enums/text-align.js';

var DEFAULT_ALIGN = TextAlign.center;
var DEFAULT_BODY_FULL_WIDTH = false;
var DEFAULT_DENSE = false;
var DEFAULT_HEADING_FULL_WIDTH = false;
var DEFAULT_INLINE = Inline.never;
var DEFAULT_INLINE_IMAGE_POSITION_RIGHT = false;
var DEFAULT_TILE = false;
/**
 * Providence Content Block component.
 * @see {@link https://providence.fmr.com/components/content-block/content-block.html|Content Block documentation}
 */
var PvdContentBlock = /** @class */ (function (_super) {
    __extends(PvdContentBlock, _super);
    function PvdContentBlock() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        //#endregion
        // #region LitElement properties
        _this.pvdAlign = DEFAULT_ALIGN;
        _this.pvdBodyFullWidth = DEFAULT_BODY_FULL_WIDTH;
        _this.pvdDense = DEFAULT_DENSE;
        _this.pvdHeadingFullWidth = DEFAULT_HEADING_FULL_WIDTH;
        _this.pvdInline = DEFAULT_INLINE;
        _this.pvdInlineImagePositionRight = DEFAULT_INLINE_IMAGE_POSITION_RIGHT;
        _this.pvdTileBackground = DEFAULT_TILE;
        return _this;
        //#endregion
    }
    Object.defineProperty(PvdContentBlock.prototype, "hasImage", {
        // #endregion
        // #region protected methods
        get: function () {
            return this.isSlotUsed('image');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PvdContentBlock.prototype, "hasHeading", {
        get: function () {
            return this.isSlotUsed('heading');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PvdContentBlock.prototype, "hasBody", {
        get: function () {
            return this.isSlotUsed();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PvdContentBlock.prototype, "hasAction", {
        get: function () {
            return this.isSlotUsed('action');
        },
        enumerable: false,
        configurable: true
    });
    // #endregion
    // #region LitElement lifecycles
    PvdContentBlock.prototype.render = function () {
        var classMap = {
            default: "".concat(this.constructor.namespace, "-content-block-root"),
            modifierPrefix: 'pvd-content-block',
            modifiers: [
                {
                    condition: this.pvdAlign !== DEFAULT_ALIGN,
                    className: "align-".concat(this.pvdAlign),
                },
                {
                    condition: this.pvdActionAlign !== undefined,
                    className: "action-align-".concat(this.pvdActionAlign),
                },
                {
                    condition: this.pvdBodyAlign !== undefined,
                    className: "body-align-".concat(this.pvdBodyAlign),
                },
                {
                    condition: this.pvdBodyFullWidth,
                    className: 'body-full-width',
                },
                {
                    condition: this.pvdDense,
                    className: 'dense',
                },
                {
                    condition: this.pvdHeadingAlign !== undefined,
                    className: "heading-align-".concat(this.pvdHeadingAlign),
                },
                {
                    condition: this.pvdHeadingFullWidth,
                    className: 'heading-full-width',
                },
                {
                    condition: this.pvdImageAlign !== undefined,
                    className: "image-align-".concat(this.pvdImageAlign),
                },
                {
                    condition: this.pvdInline !== undefined,
                    className: "inline-".concat(this.pvdInline),
                },
                {
                    condition: this.pvdInlineImagePositionRight,
                    className: 'inline-image-position-right',
                },
                {
                    condition: this.pvdTileBackground,
                    className: 'tile-background',
                },
            ],
        };
        return x(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n      <div class=\"", "\">\n        ", "\n\n        <div class=\"pvd-content-block__content-wrapper\">\n          ", "\n          ", "\n          ", "\n        </div>\n      </div>\n    "], ["\n      <div class=\"", "\">\n        ", "\n\n        <div class=\"pvd-content-block__content-wrapper\">\n          ", "\n          ", "\n          ", "\n        </div>\n      </div>\n    "])), getClassName(classMap), this.hasImage
            ? x(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n              <div class=\"pvd-content-block__image-wrapper\">\n                <s-slot name=\"image\"></s-slot>\n              </div>\n            "], ["\n              <div class=\"pvd-content-block__image-wrapper\">\n                <s-slot name=\"image\"></s-slot>\n              </div>\n            "]))) : x(templateObject_2 || (templateObject_2 = __makeTemplateObject(["<s-slot name=\"image\"></s-slot>"], ["<s-slot name=\"image\"></s-slot>"]))), this.hasHeading
            ? x(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n                <div class=\"pvd-content-block__heading-wrapper\">\n                  <div class=\"pvd-content-block__heading-content\">\n                    <s-slot name=\"heading\"></s-slot>\n                  </div>\n                </div>\n              "], ["\n                <div class=\"pvd-content-block__heading-wrapper\">\n                  <div class=\"pvd-content-block__heading-content\">\n                    <s-slot name=\"heading\"></s-slot>\n                  </div>\n                </div>\n              "]))) : x(templateObject_4 || (templateObject_4 = __makeTemplateObject(["<s-slot name=\"heading\"></s-slot>"], ["<s-slot name=\"heading\"></s-slot>"]))), this.hasBody
            ? x(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n                <div class=\"pvd-content-block__body-wrapper\">\n                  <div class=\"pvd-content-block__body-content\">\n                    <s-slot></s-slot>\n                  </div>\n                </div>\n              "], ["\n                <div class=\"pvd-content-block__body-wrapper\">\n                  <div class=\"pvd-content-block__body-content\">\n                    <s-slot></s-slot>\n                  </div>\n                </div>\n              "]))) : x(templateObject_6 || (templateObject_6 = __makeTemplateObject(["<s-slot></s-slot>"], ["<s-slot></s-slot>"]))), this.hasAction
            ? x(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n                <div class=\"pvd-content-block__action-wrapper\">\n                  <s-slot name=\"action\"></s-slot>\n                </div>\n              "], ["\n                <div class=\"pvd-content-block__action-wrapper\">\n                  <s-slot name=\"action\"></s-slot>\n                </div>\n              "]))) : x(templateObject_8 || (templateObject_8 = __makeTemplateObject(["<s-slot name=\"action\"></s-slot>"], ["<s-slot name=\"action\"></s-slot>"]))));
    };
    //#region Component configuration
    PvdContentBlock.componentName = 'content-block';
    __decorate([
        n(_assign({ type: String, reflect: true, attribute: 'pvd-align' }, PvdSlotifyBaseComponent.hasChanged(TextAlign))),
        __metadata("design:type", String)
    ], PvdContentBlock.prototype, "pvdAlign", void 0);
    __decorate([
        n(_assign({ type: String, reflect: true, attribute: 'pvd-action-align' }, PvdSlotifyBaseComponent.hasChanged(TextAlign))),
        __metadata("design:type", String)
    ], PvdContentBlock.prototype, "pvdActionAlign", void 0);
    __decorate([
        n(_assign({ type: String, reflect: true, attribute: 'pvd-body-align' }, PvdSlotifyBaseComponent.hasChanged(TextAlign))),
        __metadata("design:type", String)
    ], PvdContentBlock.prototype, "pvdBodyAlign", void 0);
    __decorate([
        n(_assign({ type: String, reflect: true, attribute: 'pvd-body-full-width' }, PvdSlotifyBaseComponent.booleanAttribute('pvd-body-full-width'))),
        __metadata("design:type", Boolean)
    ], PvdContentBlock.prototype, "pvdBodyFullWidth", void 0);
    __decorate([
        n(_assign({ type: Boolean, reflect: true, attribute: 'pvd-dense' }, PvdSlotifyBaseComponent.booleanAttribute('pvd-dense'))),
        __metadata("design:type", Boolean)
    ], PvdContentBlock.prototype, "pvdDense", void 0);
    __decorate([
        n(_assign({ type: String, reflect: true, attribute: 'pvd-heading-align' }, PvdSlotifyBaseComponent.hasChanged(TextAlign))),
        __metadata("design:type", String)
    ], PvdContentBlock.prototype, "pvdHeadingAlign", void 0);
    __decorate([
        n(_assign({ type: String, reflect: true, attribute: 'pvd-heading-full-width' }, PvdSlotifyBaseComponent.booleanAttribute('pvd-heading-full-width'))),
        __metadata("design:type", Boolean)
    ], PvdContentBlock.prototype, "pvdHeadingFullWidth", void 0);
    __decorate([
        n(_assign({ type: String, reflect: true, attribute: 'pvd-image-align' }, PvdSlotifyBaseComponent.hasChanged(TextAlign))),
        __metadata("design:type", String)
    ], PvdContentBlock.prototype, "pvdImageAlign", void 0);
    __decorate([
        n(_assign({ type: String, reflect: true, attribute: 'pvd-inline' }, PvdSlotifyBaseComponent.hasChanged(Inline))),
        __metadata("design:type", String)
    ], PvdContentBlock.prototype, "pvdInline", void 0);
    __decorate([
        n(_assign({ type: Boolean, reflect: true, attribute: 'pvd-inline-image-position-right' }, PvdSlotifyBaseComponent.booleanAttribute('pvd-inline-image-position-right'))),
        __metadata("design:type", Boolean)
    ], PvdContentBlock.prototype, "pvdInlineImagePositionRight", void 0);
    __decorate([
        n(_assign({ type: Boolean, reflect: true, attribute: 'pvd-tile-background' }, PvdSlotifyBaseComponent.booleanAttribute('pvd-tile-background'))),
        __metadata("design:type", Boolean)
    ], PvdContentBlock.prototype, "pvdTileBackground", void 0);
    return PvdContentBlock;
}(PvdSlotifyBaseComponent));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;

export { DEFAULT_ALIGN, DEFAULT_BODY_FULL_WIDTH, DEFAULT_DENSE, DEFAULT_HEADING_FULL_WIDTH, DEFAULT_INLINE, DEFAULT_INLINE_IMAGE_POSITION_RIGHT, DEFAULT_TILE, PvdContentBlock };
